import type { GroupPrivate } from '@repo/types/groups';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useDeleteGroup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => GroupService.deleteGroup(id).then((response) => response.data),
    onMutate: async (id: number) => {
      await queryClient.cancelQueries({ queryKey: [GroupKey.GROUPS] });

      const previousGroups = queryClient.getQueryData<GroupPrivate[]>([GroupKey.GROUPS]);

      queryClient.setQueryData([GroupKey.GROUPS], (prev?: GroupPrivate[]) => {
        if (!prev) {
          return [];
        }
        return prev.filter((group: GroupPrivate) => group.id !== id);
      });

      return { previousGroups };
    },
    onError: (_error, _id, context) => {
      if (context?.previousGroups) {
        queryClient.setQueryData([GroupKey.GROUPS], context.previousGroups);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [GroupKey.GROUPS] });
    },
  });
}
